<template>
    <div class="fintech-recommendation">
        <div class="text-center mb-4">
            <font-awesome-icon
                icon="fa-light fa-credit-card"
                size="2x"
                class="text-muted mb-3 d-block mx-auto opacity-50"
            />
            <h5 class="mb-2">
                {{ $t("This card can't be used right now") }}
            </h5>
            <p class="text-muted small mb-0">
                {{
                    $t(
                        "Your bank has updated its rules for online payments."
                    )
                }}
            </p>
        </div>

        <div
            v-if="recommendation.cardRecommendation === 'mastercard'"
            class="card-panel p-3"
        >
            <div class="d-flex align-items-center mb-2">
                <font-awesome-icon
                    icon="fa-brands fa-cc-mastercard"
                    size="lg"
                    class="text-warning mr-2"
                />
                <strong>{{ $t("Try a Mastercard from your bank") }}</strong>
            </div>
            <p class="small text-muted mb-0">
                {{
                    $t(
                        "Mastercards from your bank usually still work."
                    )
                }}
            </p>
        </div>

        <div
            v-else-if="recommendation.cardRecommendation === 'differentBank'"
            class="card-panel p-3"
        >
            <div class="d-flex align-items-center mb-2">
                <font-awesome-icon
                    icon="fa-light fa-building-columns"
                    size="lg"
                    class="text-primary mr-2"
                />
                <strong>{{ $t("Try a card from a different bank") }}</strong>
            </div>
            <p class="small text-muted mb-0">
                {{
                    $t(
                        "Most other banks still work normally. If you have a card from a different bank, that's the easiest fix."
                    )
                }}
            </p>
        </div>

        <div
            v-if="recommendation.cardRecommendation"
            class="or-divider text-muted text-center my-3"
        >
            <span>{{ $t("Or") }}</span>
        </div>

        <div class="px-3 mb-3">
            <h6 class="mb-2">
                {{ $t("Create a free virtual card") }}
            </h6>
            <p class="small text-muted mb-1">
                {{
                    $t(
                        "Free apps that give you a virtual card for online purchases."
                    )
                }}
            </p>
            <p class="small text-muted mb-0">
                {{
                    $t(
                        "Sign up takes a few minutes using your existing bank account."
                    )
                }}
            </p>
        </div>

        <div class="d-flex flex-column">
            <b-btn
                v-for="fintech in recommendation.fintechs"
                :key="fintech.slug"
                size="lg"
                pill
                class="fintech-btn mb-2"
                :style="fintechStyle(fintech)"
                @click="openFintech(fintech)"
            >
                <span class="d-flex align-items-center justify-content-between">
                    <span>{{ fintech.name }}</span>
                    <font-awesome-icon
                        icon="fa-light fa-arrow-up-right-from-square"
                    />
                </span>
            </b-btn>
        </div>

        <div class="text-center mt-4">
            <b-link class="small text-muted" @click="$emit('dismiss')">
                {{ $t("Try a different card") }}
            </b-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        recommendation: {
            type: Object,
            required: true,
        },
    },
    methods: {
        fintechStyle(fintech) {
            return {
                backgroundColor: "#" + fintech.brandColor,
                borderColor: "#" + fintech.brandColor,
                color: this.readableTextColor(fintech.brandColor),
            };
        },
        readableTextColor(hex) {
            const r = parseInt(hex.substr(0, 2), 16);
            const g = parseInt(hex.substr(2, 2), 16);
            const b = parseInt(hex.substr(4, 2), 16);

            const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

            return luminance > 0.6 ? "#1a1a1a" : "white";
        },
        openFintech(fintech) {
            this.$store.dispatch("system/openBrowser", fintech.signupUrl);
        },
    },
};
</script>

<style scoped>
.fintech-recommendation {
    padding: 0.5rem 0;
}

.opacity-50 {
    opacity: 0.5;
}

.card-panel {
    background: rgba(0, 0, 0, 0.04);
    border-radius: 14px;
}

.or-divider {
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.or-divider::before,
.or-divider::after {
    content: "";
    flex: 1;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
}

.or-divider span {
    padding: 0 0.75rem;
}

.fintech-btn {
    font-weight: 600;
    border: none;
    transition: transform 0.1s ease, filter 0.15s ease;
}

.fintech-btn:hover,
.fintech-btn:focus {
    filter: brightness(0.95);
    transform: translateY(-1px);
}

.fintech-btn:active {
    transform: translateY(0);
}
</style>
